import React, { useEffect } from "react";
import AuthService from "../services/auth-service/AuthService";
import { useNavigate } from "react-router-dom";

const Logout = () => {
    const navigate = useNavigate();
    useEffect(() => {
        AuthService.signOut();
        navigate({ pathname: "/" });
    }, []);

    return <div />;
};

export default Logout;
